export default __webpack_public_path__ + "atomic/_patterns/02-molecules/social_follow_links/_social_follow_links.twig";